export interface Ok<T = undefined> {
    readonly kind: 'ok';
    readonly value: T;
    readonly err?: undefined;
    readonly ok: true;
}

export interface Err<T = string> {
    readonly kind: 'err';
    readonly value?: undefined;
    readonly err: T;
    readonly ok: false;
}

export interface Aborted {
    readonly kind: 'abort';
    readonly value?: undefined;
    readonly err?: undefined;
    readonly ok?: undefined;
}

export type Result<O = undefined, E = string> = Ok<O> | Err<E>;
export type ResultWithAbort<O = undefined, E = string> = Result<O, E> | Aborted;
export type AsyncResult<O = undefined, E = string> = Promise<ResultWithAbort<O, E>>;

export function ok<T>(value: T): Ok<T>;
export function ok<T = undefined>(value?: T): Ok<undefined>;
export function ok<T>(value: T): Ok<T> {
    return {kind: 'ok', ok: true, value};
}

export function err<T>(value: T): Err<T>;
export function err<T = undefined>(value?: T): Err<undefined>;
export function err<T>(value: T): Err<T> {
    return {kind: 'err', ok: false, err: value};
}
